import { useEffect } from 'react';
import { useBreadcrumbContext } from '../../../contexts/BreadcrumbContext';
import { useSurveyAudit } from './useSurveyAudit';
import { useSurveyAuditDisplayData } from './useSurveyAuditDisplayData';

/**
 * Sets breadcrumb metadata with the audit title for the given audit ID.
 * Constructs a title like "{surveyTitle} - {date}" for the audit detail page.
 */
export const useAuditBreadcrumb = (auditId: string | undefined) => {
  const { setMetadata } = useBreadcrumbContext();

  const { data: auditData } = useSurveyAudit(auditId || '');
  const audit = auditData?.data;
  const displayData = useSurveyAuditDisplayData(audit);

  useEffect(() => {
    if (displayData.surveyTitle && !displayData.surveyTitleLoading && audit?.createdAt) {
      const dateStr = new Date(audit.createdAt)
        .toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
        })
        .replace(/\//g, '.');
      setMetadata({ auditTitle: `${displayData.surveyTitle} - ${dateStr}` });
    }
  }, [displayData.surveyTitle, displayData.surveyTitleLoading, audit?.createdAt, setMetadata]);

  useEffect(() => {
    return () => {
      setMetadata({ auditTitle: undefined });
    };
  }, [auditId, setMetadata]);
};
